import { GridLayoutProps } from 'react-grid-layout'

const GRID_GUTTERS = [16, 16] as [number, number]

export const getGridConfig = (cols: number): GridLayoutProps['gridConfig'] => ({
  cols,
  rowHeight: 280,
  margin: GRID_GUTTERS
})

/**
 * Class name to add to prevent a div from being draggable
 */
export const PREVENT_DRAG_CLASSNAME = 'drag-canceled'

export const DRAG_CONFIG: GridLayoutProps['dragConfig'] = {
  cancel: `.${PREVENT_DRAG_CLASSNAME}`
}
